import React, { useCallback } from 'react';
import type { ReactNode } from 'react';
import { useEnrollment } from '../context';
import {
  Container,
  Content,
  ErrorIcon,
  Title,
  Subtitle,
  RetryButton,
} from './error-screen.styles';

const DEFAULT_ERROR_MESSAGE = 'Algo deu errado. Por favor, tente novamente.';

export function ErrorScreen(): ReactNode {
  const { data, dispatch } = useEnrollment();

  const handleRetry = useCallback(() => {
    if (data.isAuthError) {
      dispatch({ type: 'RETRY_AUTH' });
    } else {
      dispatch({ type: 'RETRY' });
    }
  }, [data.isAuthError, dispatch]);

  return (
    <Container>
      <Content>
        <ErrorIcon>
          <ErrorSvg />
        </ErrorIcon>

        <Title>Ocorreu um erro</Title>
        <Subtitle>{data.errorMessage || DEFAULT_ERROR_MESSAGE}</Subtitle>

        {data.isTerminalError && data.intentUrl ? (
          <RetryButton onClick={() => { window.location.href = data.intentUrl; }}>
            Retornar à loja
          </RetryButton>
        ) : (
          <RetryButton onClick={handleRetry}>
            Tentar novamente
          </RetryButton>
        )}
      </Content>
    </Container>
  );
}

export function ErrorSvg(): ReactNode {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="38" stroke="#d21e32" strokeWidth="3" fill="none" />
      <path d="M28 28L52 52M52 28L28 52" stroke="#d21e32" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}
